import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { TextHighlighter } from '../../internal/components';
import { useIconMargin, useSuggestSelectedItem } from '../../internal/hooks';
import { SuggestionTitleItem } from '../../internal/components/SuggestionTitleItem';
import { SuggestionTextItem } from '../../internal/components/SuggestionTextItem';
import { ModalWindow } from '../../../modal';
import { SuggestModalMobile } from '../../internal/components/SuggestModalMobile';
import { SuggestModalMobileHeader } from '../../internal/components/SuggestModalMobileHeader';
import { SuggestionMobileDefaultItem } from '../../internal/components/SuggestionMobileDefaultItem';
import { useMaxLinesCssVarable } from '../../internal/hooks/useMaxLinesCssVarable';
import { SUGGEST_PROP_DEFAULTS } from '../../internal/constants';
import { useSuggestMouseEvents } from '../../internal/hooks/useSuggestMouseEvents';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
const suggestItemComponentMap = {
  default: SuggestionMobileDefaultItem,
  title: SuggestionTitleItem
};
export const SuggestMobile = props => {
  const {
    onSelect,
    onClose
  } = props;
  const headerRef = React.useRef(null);
  const listRef = React.useRef(null);
  useMaxLinesCssVarable({
    ref: listRef,
    maxLines: props.maxLines,
    open: props.open
  });
  const {
    getIconMarginForItem,
    setTitleItemRefByIndex
  } = useIconMargin(props.suggestions);
  const onItemClick = React.useCallback(item => () => onSelect === null || onSelect === void 0 ? void 0 : onSelect(item, {
    source: 'click'
  }), [onSelect]);
  const onModalClose = React.useCallback(() => onClose === null || onClose === void 0 ? void 0 : onClose({
    source: 'mobileModal'
  }), [onClose]);
  React.useEffect(() => {
    if (props.open && headerRef.current) {
      Array.from(headerRef.current.getElementsByTagName('input')).forEach(el => el.focus());
    }
  }, [props.open]);
  const {
    setSelectedItemIndex,
    selectedItemIndex
  } = useSuggestSelectedItem(props, {
    suggestionsChildrenRef: headerRef,
    listBoxRef: listRef
  });
  const mouseEventProps = useSuggestMouseEvents(setSelectedItemIndex);
  if (!props.open || !props.suggestions.length && !props.emptyListText && !props.showEmptySuggest) {
    return props.children;
  }
  const NoItemsComponent = !props.suggestions.length && props.emptyListText && /*#__PURE__*/_jsx(SuggestionTextItem, {
    children: props.emptyListText
  });
  return /*#__PURE__*/_jsx(ModalWindow, {
    open: true,
    onClose: onModalClose,
    title: props.title,
    height: "100%",
    width: "100%",
    fixed: true,
    header: /*#__PURE__*/_jsx(SuggestModalMobileHeader, {
      ref: headerRef,
      children: props.children
    }),
    content: /*#__PURE__*/_jsxs(SuggestModalMobile, {
      ref: listRef,
      children: [NoItemsComponent, props.suggestions.map((suggestion, i) => {
        var _suggestion$type;
        const ItemComponent = suggestItemComponentMap[(_suggestion$type = suggestion.type) !== null && _suggestion$type !== void 0 ? _suggestion$type : SUGGEST_PROP_DEFAULTS.itemType];
        return /*#__PURE__*/_createElement(ItemComponent, _objectSpread(_objectSpread({}, suggestion), {}, {
          key: i,
          type: suggestion.type,
          iconMargin: getIconMarginForItem(suggestion),
          ref: suggestion.type === 'title' ? setTitleItemRefByIndex(i) : undefined,
          onClick: onItemClick(suggestion),
          isSelected: selectedItemIndex === i,
          onMouseMove: mouseEventProps.onMouseMove(i),
          onMouseLeave: mouseEventProps.onMouseLeave,
          onMouseEnter: mouseEventProps.onMouseEnter,
          variant: "mobile"
        }), /*#__PURE__*/_jsx(TextHighlighter, {
          highlightValue: props.highlightValue,
          children: suggestion.title
        }));
      })]
    })
  });
};